__turbopack_context__.v({
  "container": "styles-module__2vB9-G__container",
  "fadeIn": "styles-module__2vB9-G__fadeIn",
  "fixedBorderBottom": "styles-module__2vB9-G__fixedBorderBottom",
  "placeholder": "styles-module__2vB9-G__placeholder",
  "stickyMobileSearchBar": "styles-module__2vB9-G__stickyMobileSearchBar",
});
